import { useLocale } from '@/contexts/localeContext';
import { TranslationKeys } from '@/contexts/TranslationKeys';
import DOMPurify from 'dompurify';
import { FC, useEffect, useState } from 'react';
import Modal from 'react-modal';
import closeIcon from '../../../images/close.svg';
import './EmailTemplatePreview.css';
import { toast } from 'react-toastify';

interface EmailTemplatePreviewModalProps {
    isPreviewOpen: boolean;
    onClose: () => void;
}

const EmailTemplatePreviewModal: FC<EmailTemplatePreviewModalProps> = ({ isPreviewOpen, onClose }) => {
    const { translate, locale } = useLocale();
    const [emailPreviewContent, setEmailPreviewContent] = useState<string>('');

    useEffect(() => {
        if (isPreviewOpen) {
            getEmailPreviewContent();
        }
    }, [isPreviewOpen]);

    const getEmailPreviewContent = async () => {
        try {
            let html = await fetch(`/email-template-preview/${locale}/emailPreview_eventBased.html`).then(res => res.text());

            /** 
                Fallback to English if the localized version is not available. 
                If we file for locale isn't available fetch will return a default html as a response hence the <!DOCTYPE html> check 
            */
            if (html.includes('<!DOCTYPE html>')) {
                html = await fetch(`/email-template-preview/en/emailPreview_eventBased.html`).then(res => res.text());
            }

            const cleanHtml = DOMPurify.sanitize(html);
            setEmailPreviewContent(cleanHtml);
        } catch (error) {
            onClose();
            toast.warn(translate.byKey(TranslationKeys.emailPreviewLoadError));
        }
    }

    return <Modal
        isOpen={isPreviewOpen}
        ariaHideApp={false}
        overlayClassName="w-screen fixed top-0 left-0 h-screen bg-opacity-75 bg-black z-50 flex items-center justify-center"
        className="bg-white border-none shadow select-none outline-none max-w-5xl mx-4 max-h-5/6 overflow-hidden rounded-lg z-50 relative">
        <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
            <div className="flex flex-row">
                <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.previewEmail)}</p>
            </div>
            <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
        </div>
        <div className="overflow-auto bg-gray-50 email-preview-container">
            <div className="ol mb-4" dangerouslySetInnerHTML={{ __html: emailPreviewContent }}/>
        </div>
    </Modal >
};

export default EmailTemplatePreviewModal;